'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const OfferLifestyleImage = require('../.././modules/shared/views/offer/offer-lifestyle-image');
const MerchantLogoImage = require('../.././modules/shared/views/merchants/merchant-logo-image');
const { getButtonUrl } = require('../../modules/support/slug-helper');

function getOfferImageSize(isTouch, innerWidth) {
  if (isTouch) {
    return innerWidth ? [`w_${innerWidth},h_136`] : ['w_400,h_136'];
  }

  return ['w_868,h_289'];
}

function getLogoImageSize(isTouch) {
  if (isTouch) {
    return ['w_68,h_68'];
  }

  return ['w_86,h_86'];
}

function Slide({
  routes,
  item,
  className,
  sizes = {},
  child = null,
  tag = 'a',
  lazy = false,
}) {
  if (!item) return null;

  const {
    merchantSlug,
    destination,
    isExclusive,
    merchantName,
    offerCallout,
    advertName,
    description,
    offerTitle,
    media,
  } = item;

  const altText = `${merchantName} - ${offerCallout}`;

  const buttonUrl = getButtonUrl({
    routes,
    merchantSlug,
    destination,
  });

  const title = offerTitle || description || advertName;

  return h(
    `${tag}.${className}`,
    {
      href: buttonUrl,
      target: !merchantSlug && '_blank',
      title,
    },
    [
      h(
        '.logo',
        OfferLifestyleImage({
          alt: altText,
          data: media,
          size: sizes.offer,
          lazyload: lazy,
        })
      ),
      MerchantLogoImage({
        className: 'merchant-logo',
        data: media,
        alt: altText,
        size: sizes.logo,
        lazyload: lazy,
      }),
      h(WithI18n, {}, i18n =>
        h(`.description${isExclusive ? '.icon-logo-g' : ''}`, [
          isExclusive && h('strong', i18n.t('js.modules.shared.Exclusive')),
          title,
        ])
      ),
      child,
    ]
  );
}

module.exports = Slide;
module.exports.getOfferImageSize = getOfferImageSize;
module.exports.getLogoImageSize = getLogoImageSize;
